export default __webpack_public_path__ + "static/media/logout.a1bd36d6.svg";